// extracted by mini-css-extract-plugin
export default {"container":"rNZDp7aY5ouVCyUgkw84","heading":"jdBgfPV8hCEgk3X7D1ws","logos":"e_ACGuVeApL8P3OGdYD2","brandsContainer":"o8Hp9W9VRv9MZ7ZhUrX6"};